import { isIOS } from './user'

const DOMAIN_WHITE_LIST = [
  'https://schedule.telmate.com',
  'https://schedule.gtl.sh',
  'https://schedule.telmate.ca',
  'https://schedule.onlinevisits.com.au',
  'https://telmate-schedule-qa-k8s.gtldev.net',
  'https://schedule-stg.telmate.com'
]
const DEV_DOMAIN = '.gtldev.net'
const IOS_APP_REDIRECT_URLS = [
  "com.telmate.govisits.qa://outcomingCall",
  "com.telmate.govisits://outcomingCall"
]

export function isValidHttpUrl(string) {
  let url

  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}

export function isValidRedirectURL(string) {
  return isValidIOSAppRedirectURL(string) || (isValidHttpUrl(string) && isURLWhitelisted(string))
}

function isURLWhitelisted(string) {
  if (!isValidHttpUrl(string)) return false
  const url = new URL(string)
  return DOMAIN_WHITE_LIST.includes(`${url.protocol}//${url.hostname}`) || url.hostname.endsWith(DEV_DOMAIN)
}

function isValidIOSAppRedirectURL(string) {
  return isIOS() && IOS_APP_REDIRECT_URLS.includes(string)
}